/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div class="paso-cuatro-container">
    <div class="form-section-header">
      <h3 class="header-icon">Paso 4: Generador de Materiales y Cotización</h3>
      <p>Configura los parámetros técnicos arriba y revisa la lista de materiales generada abajo.</p>
    </div>

    <div class="control-panel">
      <div class="panel-header">
        <h4> Parámetros de Instalación (Calculadora)</h4>
      </div>

      <div class="calculators-grid">
        <div class="calc-box">
          <h5 class="calc-title">Configuración Estructura</h5>
          <CalculadoraEstructura ref="calcEstructura" :catalogoMateriales="dbMateriales" :panelData="panelSeleccionado"
            :datosGuardados="formData.configuracionEstructura" @update-materiales="recibirMaterialesEstructura" />
        </div>

        <div class="calc-box">
          <h5 class="calc-title">Distancias y Eléctrico</h5>
          <ConfiguracionElectrica ref="calcElectrica" :inversoresIniciales="listaInversoresParaCalculo"
            :catalogoMateriales="dbMateriales" @update-costos="recibirMaterialesElectricos" />
        </div>
      </div>
    </div>

    <div class="unit-prices-editor">
      <div class="editor-header">
        <h4> Lista de Materiales Detallada</h4>

        <button type="button" class="btn pill"
          :class="{ 'btn-primary': isEditingCosts, 'btn-secondary': !isEditingCosts }" @click="toggleEditMode">
          <span v-if="!isEditingCosts">Editar Cantidades Manualmente <i class="fa-solid fa-pen-to-square"></i></span>
          <span v-else>Guardar Edición <i class="fa-solid fa-check"></i></span>
        </button>
      </div>

      <div class="tables-container">

        <div class="material-group-section">
          <h5 class="section-title-orange">Estructura y Racking</h5>
          <div class="table-responsive">
            <table class="electrical-table">
              <thead>
                <tr>
                  <th class="text-left">Artículo</th>
                  <th>Unidad</th>
                  <th class="w-small">Cant.</th>
                  <th class="w-medium">Costo U.</th>
                  <th class="w-medium">Total</th>
                  <th class="w-medium"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in localMaterialesEstructura" :key="'est-' + index">
                  <td class="text-left">
                    <input v-if="isEditingCosts" type="text" v-model="item.articulo" class="input-text-editable">
                    <span v-else>{{ item.articulo }}</span>
                  </td>
                  <td>{{ item.unidad }}</td>
                  <td>
                    <input v-if="isEditingCosts" type="number" v-model.number="item.cantidad" class="input-mini">
                    <span v-else class="dynamic-value">{{ item.cantidad }}</span>
                  </td>
                  <td>
                    <div v-if="isEditingCosts" class="input-money-mini">
                      <span>$</span>
                      <input type="number" v-model.number="item.costo" step="0.01">
                    </div>
                    <span v-else>{{ formatCurrencyValue(item.costo) }}</span>
                  </td>
                  <td class="fw-bold">{{ formatCurrency(item.cantidad * item.costo) }}</td>
                  <td v-if="isEditingCosts">
                    <button type="button" class="btn-delete-row" @click="eliminarFila('estructura', index)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button v-if="isEditingCosts" type="button" class="btn-add-row" @click="agregarFila('estructura')">+
              Agregar</button>
          </div>
        </div>
        <div class="material-group-section mt-4" v-if="localMaterialesExtras.length > 0 || isEditingCosts">
          <h5 class="section-title-orange" style="color: #ef6c00; border-color: #ffe0b2;">
            Fotovoltaico y Protecciones
          </h5>
          <div class="table-responsive">
            <table class="electrical-table">
              <thead>
                <tr>
                  <th class="text-left">Artículo</th>
                  <th>Unidad</th>
                  <th>Cant.</th>
                  <th>Costo U.</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in localMaterialesExtras" :key="'ex-' + index">
                  <td class="text-left">
                    <input v-if="isEditingCosts" type="text" v-model="item.articulo" class="input-text-editable">
                    <span v-else>{{ item.articulo }}</span>
                  </td>
                  <td>{{ item.unidad }}</td>
                  <td>
                    <input v-if="isEditingCosts" type="number" v-model.number="item.cantidad" class="input-mini">
                    <span v-else class="dynamic-value">{{ item.cantidad }}</span>
                  </td>
                  <td>
                    <div v-if="isEditingCosts" class="input-money-mini">
                      <span>$</span><input type="number" v-model.number="item.costo">
                    </div>
                    <span v-else>{{ formatCurrencyValue(item.costo) }}</span>
                  </td>
                  <td class="fw-bold">{{ formatCurrency(item.cantidad * item.costo) }}</td>
                  <td v-if="isEditingCosts">
                    <button type="button" class="btn-delete-row" @click="eliminarFila('extras', index)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button v-if="isEditingCosts" type="button" class="btn-add-row" @click="agregarFila('extras')">
              + Agregar
            </button>
          </div>
        </div>

        <div class="material-group-section mt-4" v-if="localMaterialesAnclaje.length > 0 || isEditingCosts">
          <h5 class="section-title-orange" style="color: #2e7d32; border-color: #a5d6a7;">Anclaje</h5>
          <div class="table-responsive">
            <table class="electrical-table">
              <thead>
                <tr>
                  <th class="text-left">Artículo</th>
                  <th>Unidad</th>
                  <th>Cant.</th>
                  <th>Costo U.</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in localMaterialesAnclaje" :key="'anc-' + index">
                  <td class="text-left">
                    <input v-if="isEditingCosts" type="text" v-model="item.articulo" class="input-text-editable">
                    <span v-else>{{ item.articulo }}</span>
                  </td>
                  <td>{{ item.unidad }}</td>
                  <td>
                    <input v-if="isEditingCosts" type="number" v-model.number="item.cantidad" class="input-mini">
                    <span v-else class="dynamic-value">{{ item.cantidad }}</span>
                  </td>
                  <td>
                    <div v-if="isEditingCosts" class="input-money-mini"><span>$</span><input type="number"
                        v-model.number="item.costo"></div>
                    <span v-else>{{ formatCurrencyValue(item.costo) }}</span>
                  </td>
                  <td class="fw-bold">{{ formatCurrency(item.cantidad * item.costo) }}</td>
                  <td v-if="isEditingCosts">
                    <button type="button" class="btn-delete-row" @click="eliminarFila('anclaje', index)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button v-if="isEditingCosts" type="button" class="btn-add-row" @click="agregarFila('anclaje')">+
              Agregar</button>
          </div>
        </div>

        <div class="material-group-section mt-4">
          <h5 class="section-title-orange" style="color: #c62828; border-color: #ffcdd2;">Eléctrico DC (Infraestructura)
          </h5>
          <div class="table-responsive">
            <table class="electrical-table">
              <thead>
                <tr>
                  <th class="text-left">Artículo</th>
                  <th>Unidad</th>
                  <th>Cant.</th>
                  <th>Costo U.</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in localMaterialesDC" :key="'dc-' + index">
                  <td class="text-left">
                    <input v-if="isEditingCosts" type="text" v-model="item.articulo" class="input-text-editable">
                    <span v-else>{{ item.articulo }}</span>
                  </td>
                  <td>{{ item.unidad }}</td>
                  <td>
                    <input v-if="isEditingCosts" type="number" v-model.number="item.cantidad" class="input-mini">
                    <span v-else class="dynamic-value">{{ item.cantidad }}</span>
                  </td>
                  <td>
                    <div v-if="isEditingCosts" class="input-money-mini"><span>$</span><input type="number"
                        v-model.number="item.costo"></div>
                    <span v-else>{{ formatCurrencyValue(item.costo) }}</span>
                  </td>
                  <td class="fw-bold">{{ formatCurrency(item.cantidad * item.costo) }}</td>
                  <td v-if="isEditingCosts">
                    <button type="button" class="btn-delete-row" @click="eliminarFila('dc', index)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button v-if="isEditingCosts" type="button" class="btn-add-row" @click="agregarFila('dc')">+
              Agregar</button>
          </div>
        </div>


        <div class="material-group-section mt-4">
          <h5 class="section-title-orange" style="color: #1565c0; border-color: #bbdefb;">Eléctrico AC</h5>
          <div class="table-responsive">
            <table class="electrical-table">
              <thead>
                <tr>
                  <th class="text-left">Artículo</th>
                  <th>Unidad</th>
                  <th>Cant.</th>
                  <th>Costo U.</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in localMaterialesAC" :key="'ac-' + index">
                  <td class="text-left">
                    <input v-if="isEditingCosts" type="text" v-model="item.articulo" class="input-text-editable">
                    <span v-else>{{ item.articulo }}</span>
                  </td>
                  <td>{{ item.unidad }}</td>
                  <td>
                    <input v-if="isEditingCosts" type="number" v-model.number="item.cantidad" class="input-mini">
                    <span v-else class="dynamic-value">{{ item.cantidad }}</span>
                  </td>
                  <td>
                    <div v-if="isEditingCosts" class="input-money-mini"><span>$</span><input type="number"
                        v-model.number="item.costo"></div>
                    <span v-else>{{ formatCurrencyValue(item.costo) }}</span>
                  </td>
                  <td class="fw-bold">{{ formatCurrency(item.cantidad * item.costo) }}</td>
                  <td v-if="isEditingCosts">
                    <button type="button" class="btn-delete-row" @click="eliminarFila('ac', index)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button v-if="isEditingCosts" type="button" class="btn-add-row" @click="agregarFila('ac')">+
              Agregar</button>
          </div>
        </div>

      </div>
    </div>

    <div class="step4-layout">

      <aside class="charges-sidebar">
        <div class="charge-group highlight-blue">
          <h4>Estrategia de Precio</h4>
          <div class="form-group-vertical">
            <label>Precio de Venta (USD / Watt)</label>
            <div class="input-money big-input">
              <span>$</span>
              <input type="number" step="0.01" min="0.50" :value="formData.precioVentaWatt"
                @input="updateField('precioVentaWatt', parseFloat($event.target.value))">
            </div>
            <small>Define a cuánto quieres vender el Watt instalado.</small>
          </div>
        </div>

        <hr class="sidebar-divider">

        <div class="charge-group">
          <h4>Mano de Obra</h4>
          <div class="form-group-vertical">
            <label>Costo por Panel Instalado</label>
            <div class="input-money">
              <span>$</span>
              <input type="number" :value="formData.costoUnitarioManoObra"
                @input="updateField('costoUnitarioManoObra', parseFloat($event.target.value))">
            </div>
            <small>Total MO: {{ formatCurrency(totalManoObra) }}</small>
          </div>
        </div>

        <div class="charge-group">
          <h4>Ajuste de Moneda</h4>
          <div class="form-group-vertical">
            <label>Valor del Dólar</label>
            <input type="number" :value="formData.valorDolar" @input="updateField('valorDolar', $event.target.value)"
              step="0.01" />
          </div>
        </div>

        <div class="charge-group">
          <h4>Otros Cargos / Extras</h4>
          <div class="form-group-vertical">
            <label>Monto Total ($ MXN)</label>
            <div class="input-money">
              <span>$</span>
              <input type="number" :value="formData.otrosCargos"
                @input="updateField('otrosCargos', parseFloat($event.target.value))">
            </div>
          </div>
        </div>
      </aside>

      <main class="quote-main">
        <div class="quote-header-main">
          <h3>Revisa tu cotización</h3>
          <div class="badge-potencia">
            Sistema de <strong>{{ potenciaTotalKWp }} kWp</strong>
          </div>
        </div>

        <div class="quote-table">
          <div class="quote-row header">
            <span>CONCEPTO</span>
            <span>COSTO / VALOR</span>
          </div>
          <div class="kit-box">
            <div class="quote-row item">
              <span>Paneles Solares <small>({{ formData.cantidadPaneles }} pzs)</small></span>
              <span>{{ formatCurrency(totalPaneles) }}</span>
            </div>

            <div class="quote-row item">
              <span>Inversores <small>({{ formData.cantidadInversores }} pzs)</small></span>
              <span>{{ formatCurrency(totalInversores) }}</span>
            </div>

            <div class="quote-row item">
              <span>Estructura </span>
              <span>{{ formatCurrency(totalMaterialEstructura) }}</span>
            </div>

            <div class="quote-row item" v-if="totalElectricoExtras > 0">
              <span>Material Fotovoltaico (Extras)</span>
              <span>{{ formatCurrency(totalElectricoExtras) }}</span>
            </div>
            <hr class="sidebar-divider">
            <div class="quote-row item" v-if="totalElectricoExtras > 0">
              <span> Total Material FV</span>
              <span>{{ formatCurrency(totalMAteriales) }}</span>
            </div>
          </div>
          <div class="kit-box">

            <div class="quote-row item" v-if="totalElectricoDC > 0">
              <span>Material Eléctrico DC</span>
              <span>{{ formatCurrency(totalElectricoDC) }}</span>
            </div>

            <div class="quote-row item" v-if="totalElectricoAC > 0">
              <span>Material Eléctrico AC</span>
              <span>{{ formatCurrency(totalElectricoAC) }}</span>
            </div>

            <div class="quote-row item">
              <span>Material de Anclaje</span>
              <span>{{ formatCurrency(totalMaterialAnclaje) }}</span>
            </div>

            <hr class="sidebar-divider">

            <div class="quote-row item">
              <span>Total con 10% de margen</span>
              <span>{{ formatCurrency(montoMargen10) }}</span>
            </div>
          </div>

          <div class="quote-row item">
            <span>Mano de obra</span>
            <span>{{ formatCurrency(totalManoObra) }}</span>
          </div>

          <div class="quote-row item" v-if="costoOtrosCargos > 0">
            <span>Otros Cargos</span>
            <span>{{ formatCurrency(costoOtrosCargos) }}</span>
          </div>

          <div class="quote-row subtotal-costo">
            <span>Costo Directo del Proyecto:</span>
            <strong>{{ formatCurrency(totalCostoDirecto) }}</strong>
          </div>

          <div class="quote-row item highlight-gain" :class="{ 'loss': gananciaCalculada < 0 }">
            <div style="display:flex; flex-direction:column;">
              <span>+ Tu Utilidad / Ganancia</span>
              <small v-if="gananciaCalculada >= 0">Margen: {{ porcentajeMargen }}%</small>
              <small v-else style="color:red;">Estás perdiendo dinero</small>
            </div>
            <span>{{ formatCurrency(gananciaCalculada) }}</span>
          </div>

          <div class="quote-footer">
            <div class="quote-row subtotal">
              <span>Subtotal Venta</span><span>{{ formatCurrency(subtotalVenta) }}</span>
            </div>
            <div class="quote-row iva">
              <div class="checkbox-group">
                <input type="checkbox" id="iva" :checked="formData.aplicarIVA"
                  @change="updateField('aplicarIVA', $event.target.checked)">
                <label for="iva">I.V.A. 16%</label>
              </div>
              <span>{{ formatCurrency(ivaAmount) }}</span>
            </div>

            <div class="quote-row grand-total">
              <span>PRECIO FINAL</span>
              <span>{{ formatCurrency(grandTotal) }}</span>
            </div>

            <div class="kpi-info-footer">
              Precio venta objetivo: <strong>${{ formData.precioVentaWatt }} USD / Watt</strong>
            </div>
          </div>
        </div>
      </main>
    </div>

    <div class="financing-section" v-if="financiamientosCalculados.length">
      <h3>Opciones de Financiamiento</h3>
      <div class="financing-table-wrapper">
        <table class="financing-table">
          <thead>
            <tr>
              <th class="text-left">Plan / Institución</th>
              <th>Plazo</th>
              <th>Tasa Anual</th>
              <th>Enganche Mín.</th>
              <th>Tu Enganche ($)</th>
              <th>A Financiar</th>
              <th>Mensualidad</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-contado">
              <td class="text-left">Pago de Contado</td>
              <td>-</td>
              <td>0%</td>
              <td>100%</td>
              <td>{{ formatCurrency(grandTotal) }}</td>
              <td>$0.00</td>
              <td>-</td>
            </tr>
            <tr v-for="(plan, index) in financiamientosCalculados" :key="index">
              <td class="text-left">{{ plan.nombre }}</td>
              <td>{{ plan.plazo }} meses</td>
              <td>{{ plan.tasa_interes }}%</td>
              <td>{{ plan.porcentaje_enganche }}%</td>
              <td>
                <input type="number" class="enganche-input" v-model.number="plan.engancheUsuario"
                  @input="recalcularFinanciamiento(index)">
              </td>
              <td>{{ formatCurrency(plan.montoAFinanciar) }}</td>
              <td class="fw-bold">{{ formatCurrency(plan.mensualidad) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import CalculadoraEstructura from './CalculadoraEstructura.vue';
import ConfiguracionElectrica from './ConfiguracionElectrica.vue';
import materialsService from '@/services/materialsService';

export default {
  name: 'PasoCuatro',

  components: { CalculadoraEstructura, ConfiguracionElectrica },
  props: {
    formData: { type: Object, required: true },
    financiamientos: { type: Array, required: true },
    listas: { type: Object, default: () => ({ paneles: [], inversores: [] }) }
  },
  data() {
    return {
      isEditingCosts: false,
      dbMateriales: [],
      localMaterialesDC: [], 
      localMaterialesAC: [], 
      localMaterialesEstructura: [],
      localMaterialesAnclaje: [],  
      localMaterialesElectricos: [],
      localMaterialesExtras: [],
      totalElectricoDC: 0,      
      totalElectricoAC: 0,     
      totalElectricoExtras: 0,  
      totalElectricoInfraestructura: 0,
      totalMaterialEstructura: 0,
      totalMaterialAnclaje: 0,
      totalEstructuraCalculado: 0,
      totalElectricoCalculado: 0,
      TotalMargen10: 0,
      planesFinanciamientoLocal: [],
      montoMargen10: 0,
    };
  },
  async mounted() {
    await this.cargarMateriales();
    if (!this.formData.precioVentaWatt) {
      this.updateField('precioVentaWatt', 0.85);
    }
    this.inicializarPlanes();

    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  computed: {
    panelSeleccionado() {
      if (!this.listas?.paneles) return null;
      const id = this.formData.id_panel || this.formData.idPanel;
      return this.listas.paneles.find(p => p.id == id || p.pk == id || p.id_panel == id || p.id_material == id);
    },
    inversorSeleccionado() {
      if (!this.listas?.inversores) return null;
      const id = this.formData.id_inversor || this.formData.idInversor;
      return this.listas.inversores.find(i => i.id == id || i.pk == id || i.id_inversor == id || i.id_material == id);
    },
    potenciaTotalKWp() {
      if (!this.panelSeleccionado) return 0;
      const watts = parseFloat(this.panelSeleccionado.Pmax || this.panelSeleccionado.potencia || 550);
      return ((watts * (this.formData.cantidadPaneles || 0)) / 1000).toFixed(2);
    },
    subtotalVenta() {
      const wattsTotales = parseFloat(this.potenciaTotalKWp) * 1000;
      const precioTargetUSD = parseFloat(this.formData.precioVentaWatt / 1.16);
      const tipoCambio = parseFloat(this.formData.valorDolar);
      return wattsTotales * precioTargetUSD * tipoCambio;
    },
    totalPaneles() {
      if (!this.panelSeleccionado) return 0;
      const p = this.panelSeleccionado;
      const precio = parseFloat(p.precio_unitario);
      return precio * (this.formData.cantidadPaneles) * (this.formData.valorDolar);
    },
    factorTuberiasDC() {
      const paneles = parseFloat(this.formData.cantidadPaneles || 0);
      const potenciaInv = parseFloat(this.inversorSeleccionado?.Potencia || 0);

      let divisor = 9;
      if (potenciaInv > 20000) divisor = 15;

      const stringsEstimados = Math.ceil(paneles / divisor) || 1;

      if (stringsEstimados > 4) {
        return Math.ceil(stringsEstimados / 4);
      }
      return 1;
    },
    totalInversores() {
      if (!this.inversorSeleccionado) return 0;
      const i = this.inversorSeleccionado;
      const precio = parseFloat(i.precio_unitario);
      return precio * (this.formData.cantidadInversores) * (this.formData.valorDolar);
    },
    totalManoObra() {
      return (parseFloat((this.formData.costoUnitarioManoObra)) * (this.formData.cantidadPaneles)) * 1.16;
    },
    costoOtrosCargos() { return parseFloat(this.formData.otrosCargos); },

    totalCostoDirecto() {
      return ((
        this.totalManoObra +
        this.totalMAteriales +
        this.montoMargen10
      )
        + this.costoOtrosCargos
      );
    },
    gananciaCalculada() { return this.grandTotal - this.totalCostoDirecto; },
    porcentajeMargen() {
      if (this.subtotalVenta === 0) return 0;
      return ((this.gananciaCalculada / this.subtotalVenta) * 100).toFixed(1);
    },
    ivaAmount() { return this.formData.aplicarIVA ? this.subtotalVenta * 0.16 : 0; },
    grandTotal() { return this.subtotalVenta + this.ivaAmount; },
    totalMAteriales() {
      return (parseFloat(this.totalPaneles + this.totalInversores + this.totalElectricoExtras + this.totalMaterialEstructura) * 1.16);
    },
    listaInversoresParaCalculo() {
      const lista = [];
      let modelo = this.inversorSeleccionado?.Articulo || 'Inversor Sistema';
      let totalInversores = parseInt(this.formData.cantidadInversores);
      let totalPaneles = parseInt(this.formData.cantidadPaneles);

      let potenciaReal = parseFloat(this.inversorSeleccionado?.Potencia);
      let iscReal = parseFloat(this.panelSeleccionado?.ISC);
      let corrienteAC = parseFloat(this.inversorSeleccionado?.corriente);
      let fasesInversor = this.inversorSeleccionado?.id_fasica;

      const configGuardada = this.formData.configuracionInversores || [];

      const panelesPorInv = Math.floor(totalPaneles / totalInversores);
      const sobrante = totalPaneles % totalInversores;

      for (let i = 0; i < totalInversores; i++) {
        const guardado = configGuardada[i] || {};

        lista.push({
          id: i,
          modelo: modelo,
          potenciaW: potenciaReal,
          isc: iscReal,
          fases: fasesInversor,
          corrienteAC: corrienteAC,
          cantidadPaneles: i === totalInversores - 1 ? panelesPorInv + sobrante : panelesPorInv,

          distanciaDC: guardado.distanciaDC !== undefined ? guardado.distanciaDC : 15,
          distanciaAC: guardado.distanciaAC !== undefined ? guardado.distanciaAC : 10
        });
      }
      return lista;
    },
    financiamientosCalculados() { return this.planesFinanciamientoLocal; }
  },
  watch: {
    grandTotal() { this.syncFormData(); },

    localMaterialesEstructura: { deep: true, handler() { if (this.isEditingCosts) this.recalcularTotalesManuales(); } },
    localMaterialesAnclaje: { deep: true, handler() { if (this.isEditingCosts) this.recalcularTotalesManuales(); } },

    localMaterialesDC: {
      deep: true,
      handler() { if (this.isEditingCosts) this.recalcularTotalesManuales(); }
    },
    localMaterialesAC: {
      deep: true,
      handler() { if (this.isEditingCosts) this.recalcularTotalesManuales(); }
    },
    localMaterialesExtras: {
      deep: true,
      handler() { if (this.isEditingCosts) this.recalcularTotalesManuales(); }
    }
  },
  methods: {
    agregarFila(tipo) {
      const itemVacio = { articulo: 'Nuevo Item', unidad: 'Pza', cantidad: 1, costo: 0, total: 0 };

      if (tipo === 'estructura') this.localMaterialesEstructura.push(itemVacio);
      if (tipo === 'anclaje') this.localMaterialesAnclaje.push(itemVacio);
      if (tipo === 'dc') this.localMaterialesDC.push(itemVacio);
      if (tipo === 'ac') this.localMaterialesAC.push(itemVacio);
      if (tipo === 'extras') this.localMaterialesExtras.push(itemVacio);
    },
    async cargarMateriales() {
      try { const res = await materialsService.getAllMateriales(); this.dbMateriales = res.data; }
      catch (e) { console.error(e); }
    },
    eliminarFila(tipo, index) {
      if (tipo === 'estructura') this.localMaterialesEstructura.splice(index, 1);
      if (tipo === 'anclaje') this.localMaterialesAnclaje.splice(index, 1);
      if (tipo === 'dc') this.localMaterialesDC.splice(index, 1);
      if (tipo === 'ac') this.localMaterialesAC.splice(index, 1);
      if (tipo === 'extras') this.localMaterialesExtras.splice(index, 1);

    },
    actualizarMargen() {
      const baseParaMargen = this.totalElectricoDC + this.totalElectricoAC + this.totalMaterialAnclaje;
      const ivaBaseMrge = baseParaMargen * 1.16
      this.montoMargen10 = ivaBaseMrge * 1.10;
    },

    recibirMaterialesEstructura(payload) {
      if (this.isEditingCosts) return;

      this.localMaterialesEstructura = payload.listaEstructura || [];
      this.localMaterialesAnclaje = payload.listaAnclaje || [];

      const costoEst = this.localMaterialesEstructura.reduce((sum, item) => sum + item.total, 0);
      const costoAnc = this.localMaterialesAnclaje.reduce((sum, item) => sum + item.total, 0);

      this.totalEstructuraCalculado = costoEst + costoAnc;
      if (payload.configuracionInput) {
        this.$emit('update:formData', {
          configuracionEstructura: payload.configuracionInput
        });
      }
      this.totalMaterialEstructura = costoEst * (this.formData.valorDolar);
      this.totalMaterialAnclaje = costoAnc;
      this.actualizarMargen();
    },
    recibirMaterialesElectricos(payload) {
      if (this.isEditingCosts) return;

      this.localMaterialesDC = payload.listaDC || [];
      this.localMaterialesAC = payload.listaAC || [];
      this.localMaterialesExtras = payload.listaExtras || [];

      const sumar = (arr) => arr.reduce((s, i) => s + i.total, 0);
      const costoDC_Base = sumar(this.localMaterialesDC);
      const costoAC = sumar(this.localMaterialesAC);
      const costoExtras = sumar(this.localMaterialesExtras);

      this.totalElectricoDC = costoDC_Base * this.factorTuberiasDC;
      this.totalElectricoAC = costoAC;
      this.totalElectricoExtras = costoExtras * this.formData.valorDolar;
      this.totalElectricoCalculado = this.totalElectricoDC + this.totalElectricoAC + this.totalElectricoExtras;
if (payload.configuracionInversores) {
        
        const nuevaConfig = JSON.stringify(payload.configuracionInversores);
        const actualConfig = JSON.stringify(this.formData.configuracionInversores || []);

        if (nuevaConfig !== actualConfig) {
            this.$emit('update:formData', {
                configuracionInversores: payload.configuracionInversores
            });
        }
      }

      this.actualizarMargen();
    },
    toggleEditMode() {
      this.isEditingCosts = !this.isEditingCosts;
      if (!this.isEditingCosts) this.recalcularTotalesManuales();
    },
    recalcularTotalesManuales() {
      const sumar = (lista) => lista.reduce((acc, item) => acc + (item.cantidad * item.costo), 0);

      this.totalEstructuraCalculado = sumar(this.localMaterialesEstructura) + sumar(this.localMaterialesAnclaje);

      const tDC = sumar(this.localMaterialesDC);
      const tAC = sumar(this.localMaterialesAC);
      const tExtras = sumar(this.localMaterialesExtras);

      this.totalElectricoDC = tDC;
      this.totalElectricoAC = tAC;
      this.totalElectricoExtras = tExtras * this.formData.valorDolar;

      this.totalElectricoCalculado = tDC + tAC + tExtras;
      this.actualizarMargen();
    },
    updateField(field, value) { this.$emit('update:formData', { [field]: value }); },
    formatCurrency(val) { return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0); },
    formatCurrencyValue(val) { return (val || 0).toFixed(2); },

    syncFormData() {
      const listaEstructuraCompleta = [...this.localMaterialesEstructura, ...this.localMaterialesAnclaje];
      const listaElectricaCompleta = [...this.localMaterialesDC, ...this.localMaterialesAC, ...this.localMaterialesExtras];

      this.$emit('update:formData', {
        granTotalGuardado: this.grandTotal,
        subtotalGuardado: this.subtotalVenta,
        gananciaGuardada: this.gananciaCalculada,
        ivaGuardado: this.ivaAmount,
        manoObraGuardada: this.totalManoObra,
        otrosCargos: this.costoOtrosCargos,
        CostoDirecto: this.totalCostoDirecto,
        precioPanelesGuardado: this.totalPaneles,
        precioInversoresGuardado: this.totalInversores,
        totalEstructuraGuardado: this.totalMaterialEstructura, 
        totalElectricoExtrasGuardado: this.totalElectricoExtras,
        totalMaterialFVGuardado: (this.totalPaneles + this.totalInversores + this.totalElectricoExtras + this.totalMaterialEstructura),
        totalElectricoDCGuardado: this.totalElectricoDC,
        totalElectricoACGuardado: this.totalElectricoAC,
        totalMaterialAnclajeGuardado: this.totalMaterialAnclaje,
        totalConMargen10Guardado: this.montoMargen10,
        configuracionInversores: this.formData.configuracionInversores || [],
        datosEstructuraPDF: listaEstructuraCompleta,
        datosElectricoPDF: listaElectricaCompleta,
        configuracionEstructura: this.$refs.calcEstructura ? JSON.parse(JSON.stringify(this.$refs.calcEstructura.secciones)) : []
      });

      this.$emit('update:materiales-listas', {
        estructura: listaEstructuraCompleta,
        electrico: listaElectricaCompleta
      });

      if (this.planesFinanciamientoLocal) {
        this.planesFinanciamientoLocal.forEach((_, i) => this.recalcularFinanciamiento(i));
      }
    },

    inicializarPlanes() {
      if (!this.financiamientos.length) return;
      this.planesFinanciamientoLocal = this.financiamientos.map(plan => ({
        ...plan,
        montoEngancheMin: 0, engancheUsuario: 0, montoAFinanciar: 0, mensualidad: 0
      }));
      this.planesFinanciamientoLocal.forEach((_, i) => this.recalcularFinanciamiento(i));
    },
    recalcularFinanciamiento(index) {
      const plan = this.planesFinanciamientoLocal[index];
      const minEnganche = this.grandTotal * (plan.porcentaje_enganche / 100);
      if (plan.engancheUsuario < minEnganche) plan.engancheUsuario = Math.round(minEnganche);
      let capital = this.grandTotal - plan.engancheUsuario;
      if (capital < 0) capital = 0;
      plan.montoAFinanciar = capital;
      if (capital > 0) {
        if (plan.tasa_interes > 0) {
          const i = (plan.tasa_interes / 100) / 12;
          const n = plan.plazo;
          plan.mensualidad = capital * (i * Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
        } else {
          plan.mensualidad = capital / plan.plazo;
        }
      } else { plan.mensualidad = 0; }
    }
  }
}
</script>

<style scoped>
:root {
  --color-primario: #29b9f6;
  --color-secundario: #333;
  --color-fondo-claro: #f8f9fa;
  --color-borde: #dee2e6;
}

.paso-cuatro-container {
  padding-bottom: 50px;
}

.form-section-header {
  margin-bottom: 25px;
}

.control-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 30px;
  padding: 20px;
}

.panel-header h4 {
  margin: 0 0 15px 0;
  color: #29b9f6;
  font-size: 16px;
  font-weight: 700;
}

.calculators-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.calc-box {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
}

.calc-title {
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: 700;
  color: #555;
  border-bottom: 2px solid #eee;
  padding-bottom: 5px;
}

.unit-prices-editor {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 30px;
}

.kit-box {
  border: 2px solid #29b9f6;
  border-radius: 12px;
  padding: 15px;
  background-color: #f0f9ff;
  margin-bottom: 15px;
  position: relative;
}

.item-inside {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #cbd5e1;
}

.item-inside:last-child {
  border-bottom: none;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.editor-header h4 {
  margin: 0;
  font-size: 18px;
  color: var(--color-primario);
}

.electrical-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
}

.electrical-table th {
  background: #333;
  color: #fff;
  padding: 8px;
  text-align: left;
}

.electrical-table td {
  border-bottom: 1px solid #eee;
  padding: 8px;
  vertical-align: middle;
}

.dynamic-value {
  color: #29b9f6;
  font-weight: 700;
}

.input-mini {
  width: 60px;
  text-align: center;
  border: 1px solid #ccc;
  padding: 3px;
  border-radius: 4px;
}

.section-title-orange {
  color: #e65100;
  font-size: 14px;
  font-weight: 700;
  border-bottom: 2px solid #ffe0b2;
  padding-bottom: 5px;
  margin-bottom: 10px;
}

.mt-4 {
  margin-top: 30px;
}

.empty-msg {
  text-align: center;
  color: #999;
  font-style: italic;
  padding: 20px;
}

.btn-delete-row {
  background: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-delete-row:hover {
  background: #c62828;
  color: white;
}

.step4-layout {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 30px;
  align-items: start;
}

.charges-sidebar {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  border: 1px solid var(--color-borde);
}

.charge-group h4 {
  margin: 0 0 10px 0;
  font-size: 15px;
  color: #333;
  font-weight: 700;
}

.form-group-vertical {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 15px;
}

.form-group-vertical label {
  font-size: 13px;
  color: #666;
  font-weight: 600;
}

.input-money {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0 10px;
  background: #fff;
}

.input-money input,
.form-group-vertical>input {
  border: none;
  outline: none;
  width: 100%;
  padding: 8px;
  font-size: 14px;
  text-align: right;
}

.form-group-vertical>input {
  border: 1px solid #ddd;
  border-radius: 6px;
}

.highlight-blue {
  background: #e3f2fd;
  border: 1px solid #90caf9;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.highlight-blue h4 {
  color: #1565c0;
  margin-bottom: 10px;
}

.big-input input {
  font-size: 18px;
  color: #1565c0;
  font-weight: bold;
}

.quote-main {
  background: #fff;
  border: 1px solid var(--color-borde);
  border-radius: 12px;
  overflow: hidden;
}

.quote-header-main {
  padding: 20px 25px;
  background: #f8fafc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.quote-header-main h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.badge-potencia {
  background: #29b9f6;
  color: white;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 13px;
}

.quote-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 25px;
  border-bottom: 1px solid #f9f9f9;
  align-items: center;
}

.quote-row.header {
  font-weight: 700;
  color: #999;
  font-size: 11px;
  background: #fff;
}

.subtotal-costo {
  background: #eee;
  font-weight: 700;
  color: #555;
  border-top: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
}

.highlight-gain {
  background: #f1f8e9;
  color: #2e7d32;
  font-weight: 700;
  font-size: 1.1em;
}

.highlight-gain.loss {
  background: #ffebee;
  color: #c62828;
}

.quote-footer {
  background: #fafafa;
  padding-top: 10px;
}

.quote-row.grand-total {
  background: #2d3748;
  color: #fff;
  padding: 20px 30px;
  font-size: 1.3em;
  font-weight: 700;
}

.quote-row.grand-total span {
  color: #fff;
}

.kpi-info-footer {
  text-align: center;
  padding: 10px;
  color: #1565c0;
  font-size: 12px;
  background: #e3f2fd;
}

.financing-section {
  margin-top: 40px;
}

.financing-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
}

.financing-table th {
  background: #f1f3f5;
  padding: 10px;
  text-align: right;
}

.financing-table td {
  border-bottom: 1px solid #eee;
  padding: 10px;
  text-align: right;
}

.financing-table .text-left {
  text-align: left;
}

.enganche-input {
  width: 90px;
  text-align: right;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.row-contado {
  background: #f0f9ff;
}

@media (max-width: 1024px) {

  .calculators-grid,
  .step4-layout {
    grid-template-columns: 1fr;
  }

  .charges-sidebar {
    order: 2;
  }
}
</style>